import React from 'react'
import compact from 'lodash/compact'
import { matchPath, Redirect } from 'react-router'
import { getCookieValue, setCookieValue } from 'utils/cookies';
import { LANGUAGES } from '../constants'
import config from '../../config'
import Main from './Main'

export default props => {
  const { history } = props;
  const { pathname: path, search } = history.location;

  const langRouter = LANGUAGES.map(lang =>
    matchPath(path, {
      path: `/${lang._id}`,
      exact: false,
      strict: false
    })
  )
  const filtredLang = compact(langRouter)
  const language = filtredLang[0] ? filtredLang[0].path.substr(1) : 'lv'
  const langFromCookie = getCookieValue('language');

  if (typeof window !== 'undefined') {
    window.gtag && gtag('config', config.google.trackingId, {
      'page_path': path,
    });

    if (langFromCookie && langFromCookie !== language) {
      if (langFromCookie === 'lv' && path === `/${language}`) {
        setCookieValue('language', 'lv');
        return <Redirect to='/' />

      } else if ((language === 'lv' && path === '/') || path === `/${language}`) {
        setCookieValue('language', langFromCookie);
        return <Redirect to={`/${langFromCookie}`} />
      }

      setCookieValue('language', language);
    }
  }

  return <Main lang={language} path={path} history={history} search={search} />
}



// WEBPACK FOOTER //
// ./src/components/App.js